import { render, staticRenderFns } from "./Voucher.vue?vue&type=template&id=60c99d30&scoped=true&"
import script from "./Voucher.vue?vue&type=script&lang=js&"
export * from "./Voucher.vue?vue&type=script&lang=js&"
import style0 from "./Voucher.vue?vue&type=style&index=0&id=60c99d30&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60c99d30",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('60c99d30')) {
      api.createRecord('60c99d30', component.options)
    } else {
      api.reload('60c99d30', component.options)
    }
    module.hot.accept("./Voucher.vue?vue&type=template&id=60c99d30&scoped=true&", function () {
      api.rerender('60c99d30', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-4vB46NYzGL6sF/JS/comp/Voucher.vue"
export default component.exports